/**
 * Icons preview: http://simplelineicons.com
 */

export default {
  items: [
    {
      key: 'header_title_learning',
      url: '/trainings',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/_Header/_nav.js